module.exports = __webpack_public_path__ + "static/img/年度最佳耳机.a7e11612.png";